import { invalidateQueries } from '@/utils/tanstack';
import { GET_REGISTRATION_ERROR_QUERY_KEY } from '@app/hooks/queries/registration/useGetRegistrationErrorQuery/types';

export const invalidateGetRegistrationErrorQuery = () => {
  invalidateQueries([GET_REGISTRATION_ERROR_QUERY_KEY])
    .then()
    .catch(() => undefined);
};
